// [part, pivot x, pivot y, swing sign]

export const limbs = [
  ['body', 0, 0, 0],
  ['leg', -0.09, 0.9, 1],
  ['leg', 0.09, 0.9, -1],
  ['arm', -0.25, 1.42, -1],
  ['arm', 0.25, 1.42, 1]
];
